import { h, Host } from "@stencil/core";
import * as monaco from "@timkendrick/monaco-editor";
export class DnnMonacoEditor {
    constructor() {
        /** Defines the language for the editor. */
        this.language = "html";
        /** Sets the code contained in the editor */
        this.value = "";
        this.focused = false;
    }
    languageChanged(newValue, oldValue) {
        if (newValue != oldValue) {
            monaco.editor.setModelLanguage(this.editor.getModel(), newValue);
        }
    }
    valueChanged(newValue, oldValue) {
        if (newValue != oldValue) {
            this.editor.setValue(newValue);
        }
    }
    componentDidLoad() {
        this.originalValue = this.value;
        this.editor = monaco.editor.create(this.editorContainer, {
            value: this.value,
            language: this.language,
            theme: "vs-dark",
            automaticLayout: true,
        });
        this.setFormValue();
        this.editor.onDidChangeModelContent(() => {
            this.value = this.editor.getValue();
            this.contentChanged.emit(this.value);
            this.setFormValue();
        });
        this.textArea = this.editorContainer.querySelector("textarea");
        this.textArea.addEventListener("focus", () => {
            this.focused = true;
        });
        this.textArea.addEventListener("blur", () => this.focused = false);
        this.textArea.addEventListener("focus", () => this.focused = true);
    }
    formResetCallback() {
        this.internals.setValidity({});
        this.value = this.originalValue;
        this.setFormValue();
    }
    focusElement() {
        var element = this.editorContainer.querySelector("textarea");
        element.focus();
    }
    setFormValue() {
        if (this.name != undefined) {
            var data = new FormData();
            data.append(this.name, this.value);
            this.internals.setFormValue(data);
        }
    }
    render() {
        return (h(Host, { key: 'f7984d620c0eafff7b465ee2682440bc686e49aa', tabIndex: this.focused ? -1 : 0, onFocus: () => this.focusElement(), onBlur: () => this.textArea.blur() }, h("div", { key: 'f547c173961b87fcab04ec4790fe57b02ca0621b', class: "editor-container", ref: el => this.editorContainer = el })));
    }
    static get is() { return "dnn-monaco-editor"; }
    static get encapsulation() { return "scoped"; }
    static get formAssociated() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-monaco-editor.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-monaco-editor.css"]
        };
    }
    static get properties() {
        return {
            "language": {
                "type": "string",
                "attribute": "language",
                "mutable": false,
                "complexType": {
                    "original": "\"plaintext\" | \"bat\" | \"coffeescript\" | \"c\" | \"cpp\" | \"csharp\" | \"dockerfile\" | \"fsharp\" | \"go\" | \"handlebars\" | \"html\" | \"ini\" | \"pug\" | \"java\" | \"lua\" | \"markdown\" | \"msdax\" | \"objective-c\" | \"postiats\" | \"php\" | \"powershell\" | \"python\" | \"r\" | \"razor\" | \"ruby\" | \"swift\" | \"sql\" | \"vb\" | \"xml\" | \"less\" | \"scss\" | \"css\" | \"yaml\" | \"sol\" | \"sb\" | \"json\" | \"typescript\" | \"javascript\"",
                    "resolved": "\"html\" | \"ruby\" | \"plaintext\" | \"r\" | \"bat\" | \"coffeescript\" | \"c\" | \"cpp\" | \"csharp\" | \"dockerfile\" | \"fsharp\" | \"go\" | \"handlebars\" | \"ini\" | \"pug\" | \"java\" | \"lua\" | \"markdown\" | \"msdax\" | \"objective-c\" | \"postiats\" | \"php\" | \"powershell\" | \"python\" | \"razor\" | \"swift\" | \"sql\" | \"vb\" | \"xml\" | \"less\" | \"scss\" | \"css\" | \"yaml\" | \"sol\" | \"sb\" | \"json\" | \"typescript\" | \"javascript\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines the language for the editor."
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"html\""
            },
            "value": {
                "type": "string",
                "attribute": "value",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the code contained in the editor"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "attribute": "name",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The name of the control to use for forms."
                },
                "getter": false,
                "setter": false,
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "contentChanged",
                "name": "contentChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the new value of the content when it is changed."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "language",
                "methodName": "languageChanged"
            }, {
                "propName": "value",
                "methodName": "valueChanged"
            }];
    }
    static get attachInternalsMemberName() { return "internals"; }
}
//# sourceMappingURL=dnn-monaco-editor.js.map
